/** When your routing table is too long, you can split it into small modules**/

export default [
  {
    path: "/reports/payments",
    name: "reportpayments",
    component: () => import("@/views/reporter/Payments"),
  },
  {
    path: "/reports/paybacks",
    name: "reportpaybacks",
    component: () => import("@/views/reporter/Paybacks"),
  },
];
